import { subDays } from "date-fns";

/** Whether `timestamp` falls within the `days` days that end at `now`. */
export function isWithinDays(timestamp: string, days: number, now: number | Date = Date.now()) {
  return new Date(timestamp) >= subDays(now, days);
}
